import React from "react";
import Onboarding from "./Onboarding";

const SponsorAppTour = () => {
  return <Onboarding />;
};

export default SponsorAppTour;
